import { LineLotInterface } from '../lineLot/types';
import { BenefitInterface } from '../benefits/types';
import { StopInterface as StopBaseInterface } from '../stops/types';
import { FareInterface as FareBaseInterface } from '../fares/types';
import { SectionInterface as SectionBaseInterface } from '../sections/types';
import { ItineraryInterface } from '../itineraries/types';
import { TollInterface } from '../tolls/types';
import { LineTransportOperator } from '../linesMatrixIntegration/types';

/*
 * Action Types
 */
export enum LinesTypes {
  LIST_LINES_REQUEST = '@lines/LIST_LINES_REQUEST',
  LIST_LINES_SUCCESS = '@lines/LIST_LINES_SUCCESS',
  LIST_LINES_FAILURE = '@lines/LIST_LINES_FAILURE',

  FILTER_LINES_REQUEST = '@lines/FILTER_LINES_REQUEST',
  FILTER_LINES_SUCCESS = '@lines/FILTER_LINES_SUCCESS',
  FILTER_LINES_FAILURE = '@lines/FILTER_LINES_FAILURE',

  GET_LINE_REQUEST = '@lines/GET_LINE_REQUEST',
  GET_LINE_SUCCESS = '@lines/GET_LINE_SUCCESS',
  GET_LINE_FAILURE = '@lines/GET_LINE_FAILURE',

  CREATE_LINE_REQUEST = '@lines/CREATE_LINE_REQUEST',
  CREATE_LINE_SUCCESS = '@lines/CREATE_LINE_SUCCESS',
  CREATE_LINE_FAILURE = '@lines/CREATE_LINE_FAILURE',

  UPDATE_LINE_REQUEST = '@lines/UPDATE_LINE_REQUEST',
  UPDATE_LINE_SUCCESS = '@lines/UPDATE_LINE_SUCCESS',
  UPDATE_LINE_FAILURE = '@lines/UPDATE_LINE_FAILURE',

  DELETE_LINE_REQUEST = '@lines/DELETE_LINE_REQUEST',
  DELETE_LINE_SUCCESS = '@lines/DELETE_LINE_SUCCESS',
  DELETE_LINE_FAILURE = '@lines/DELETE_LINE_FAILURE',

  UPDATE_LINE_BENEFITS_REQUEST = '@lines/UPDATE_LINE_BENEFITS_REQUEST',
  UPDATE_LINE_BENEFITS_SUCCESS = '@lines/UPDATE_LINE_BENEFITS_SUCCESS',
  UPDATE_LINE_BENEFITS_FAILURE = '@lines/UPDATE_LINE_BENEFITS_FAILURE',

  CONECTIVITY_REQUEST = '@CONECTIVITY/CONECTIVITY_REQUEST',
  CONECTIVITY_SUCCESS = '@CONECTIVITY/CONECTIVITY_SUCCESS',
  CONECTIVITY_FAILURE = '@CONECTIVITY/CONECTIVITY_FAILURE',

  UPDATE_LINE_FARE_REQUEST = '@line/UPDATE_LINE_FARE_REQUEST',
  UPDATE_LINE_FARE_SUCCESS = '@line/UPDATE_LINE_FARE_SUCCESS',
  UPDATE_LINE_FARE_FAILURE = '@line/UPDATE_LINE_FARE_FAILURE',

  CONECTIVITY_DATA_PLAN_SUCCESS = '@CONECTIVITY/CONECTIVITY_DATA_PLAN_SUCCESS',
}

/*
 * Data types
 */
export interface LineStopBaseInterface {
  id: string;
  order: number;
  way: number;
  busStop: boolean;
  busTurn: boolean;
  visible: boolean;
  lineId: string;
  stopId: string;
  lineSectionId: string;
  createdAt: string;
  updatedAt: string;
}

export interface SectionFareResumeInterface {
  result: number;
  subsidy: number;
  tax: number;
  toll: number;
  value: number;
}

export interface LineSectionBaseInterface {
  id: string;
  shortId: string;
  main: boolean;
  deleted?: boolean;
  order: number;
  way: number;
  route: object | string | null; // geojson | geojson url
  lineId: string;
  sectionId: string;
  fareId: string;
  finalValue: SectionFareResumeInterface;
  name?: string;
  createdAt: string;
  updatedAt: string;
  Section?: SectionBaseInterface;
}

export interface LineStopInterface extends LineStopBaseInterface {
  Stop: StopBaseInterface;
}

export interface SectionInterface extends SectionBaseInterface {
  LineSection: LineSectionBaseInterface & {
    Fare: FareBaseInterface;
    Tolls: TollInterface[];
  };
}
export interface FareTaxValueInterface {
  id: string;
  from: number | null;
  to: number | null;
  value: number;
  valueType: string;
  codeFareTax?: string | null;
  hasFreeIndicator?: boolean | null;
  createdAt: string;
  updatedAt: string;
  fareTaxId: string;
}

export interface FareTaxStopLineSectionInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  fareTaxId: string;
  stopId: string;
  lineSectionId: string;
}

export interface FareTaxInterface {
  id: string;
  name: string;
  validFrom: string;
  keepUntil: string | null;
  type: string;
  checkEntry: string | null;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  fareTaxIntegratorId: string | null;
  FareTaxStopLineSection: FareTaxStopLineSectionInterface;
  FareTaxValues: FareTaxValueInterface[];
}

export interface LineSectionSeatFaresInterface {
  operation?: number | 'ADD' | 'REMOVE';
  seatCategory: string;
  type: string;
  value: number;
}

export interface LineSectionsInterface extends LineSectionBaseInterface {
  Fare: FareBaseInterface;
  Tolls: TollInterface[];
  Section: SectionBaseInterface;
  Line: LineBaseInterface;
  km?: number;
  FareTaxes?: FareTaxInterface[];
  LineSectionSeatFares?: LineSectionSeatFaresInterface[];
}

export interface LineBaseInterface {
  id: string;
  name: string;
  prefix: string;
  status: number;
  visible?: boolean;
  sellingAllowed?: boolean;
  blockByCount?: boolean;
  automaticChangeGo?: boolean;
  automaticChangeBack?: boolean;
  bpe?: boolean;
  LineProfileReservations?: {
    id: string;
    profileId: string;
    quantity: number;
  }[];
  type: number;
  distributionType: number;
  lineType: number;
  lineFunction: number;
  model: number;
  sector: string;
  system: string;
  operation: number;
  color: string;
  minVelocity: number;
  maxVelocity: number;
  updatedAt: string;
  createdAt: string;
  lineLotId: string;
  freeTerminalOnly?: boolean;
  freeTimeLimit?: number;
  transportOperatorId: string;
  TransportOperator?: LineTransportOperator;
}

export interface LineInterface extends LineBaseInterface {
  Stops?: StopBaseInterface[];
  Sections?: SectionInterface[];
  LineSections?: LineSectionsInterface[];
  LineStops?: LineStopInterface[];
  Benefits?: BenefitInterface[];
  LineLot?: LineLotInterface;
  goGeoJson?: string; // url
  backGeoJson?: string; // url
  goRoute?: string;
  backRoute?: string;
  Itineraries?: ItineraryInterface[];
}

export interface ConectivityInterfacce {
  purchases: { latitude: number; longitude: number }[];
  usages: { latitude: number; longitude: number }[];
  offlines: { latitude: number; longitude: number }[];
  onlines: { latitude: number; longitude: number }[];
  exits: { latitude: number; longitude: number }[];
}
export interface ConectivityDataPlanInterfacce {
  dbdId: string;
  plan: string;
  available: string;
  used: string;
  carrier: string;
  signalQuality: number;
  renew: string;
  daysToRenew: string;
}
/*
 * State type
 */
export interface LinesState {
  readonly linesList: LineInterface[];
  readonly lineData: LineInterface;
  readonly conectivityData: ConectivityInterfacce;
  readonly conectivityDataPlanList: ConectivityDataPlanInterfacce[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly conectivityError: string;
  readonly internalCode: string;
}
